module.exports = __webpack_public_path__ + "static/media/text-height.834bedbf.svg";